import React, { useState } from "react";
import { PageHead } from "../components/PageHead";
import { DataTable } from "../components/DataTable";
import { EquipmentModal } from "../components/EquipmentModal";
import { DisciplineBadge } from "../components/Badges";
import { fmtDate } from "../lib/format";

export default function CustHistory() {
  const [sel, setSel] = useState(null);
  const columns = [
    { key: "description", label: "Equipment", sortable: true, render: (v, row) => <span className="cell-2" style={{ display: "inline-flex" }}><span className="t-strong">{v || "—"}</span><span className="s">{row.manufacturer || ""}</span></span> },
    { key: "serial_number", label: "Serial / issue", sortable: true, mono: true, render: (v, row) => v || row.issue_number || "—" },
    { key: "discipline", label: "Discipline", sortable: true, render: (v) => <DisciplineBadge name={v} /> },
    { key: "last_calibration_date", label: "Last cal.", sortable: true, mono: true, render: (v) => <span className="t-mut">{fmtDate(v)}</span> },
    { key: "calibration_due_date", label: "Next due", sortable: true, mono: true, render: (v, row) => row.scrapped ? "Unserviceable" : fmtDate(v) },
  ];
  return (
    <>
      <PageHead crumb="My Account" title="Calibration History"
        sub="A complete, permanent record of every calibration we have performed for you. Click a row for the full timeline." />
      <DataTable endpoint="/equipment" columns={columns} rowKey="id" testid="cust-history"
        defaultSort={{ by: "last_calibration_date", dir: "desc" }} searchPlaceholder="Search your equipment…"
        onRowClick={(row) => setSel(row.id)} />
      {sel && <EquipmentModal id={sel} canEdit={false} onClose={() => setSel(null)} onChanged={() => {}} />}
    </>
  );
}
